<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item active" @click="switchTab('transactions')">
          TRANSACTIONS
        </div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('earning_report')">
          EARNING REPORT
        </div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('tax')">TAX</div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('settlement')">SETTLEMENT</div>
      </div>
      <div class="tab-options">
        <b-input placeholder="Search..." id="mySearch" type="search" icon-pack="fas" icon="search" custom-class="input-size"
          v-model="form_filter.query" @input="searchTransations">
        </b-input>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_transations && finance_data" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Profile</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Payed With</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
            <tr v-for="(item, index) in finance_data.data" :key="index" @click="selectTransation(item)">
              <td>
                <widgetProfile v-if="item.user" :title="`${item.user.first_name} ${item.user.last_name}`" subtitle=""
                  :file_name="item.user.profile_image" :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'">
                </widgetProfile>
                <div v-else>UnKnown</div>
              </td>
              <td>{{ item.transactionid }}</td>
              <td>{{ `${item.currency} ${item.amount}` }}</td>
              <td>
                {{ item.payment_type }}
              </td>
              <td>
                <b-tag v-if="item.status == 'payed'" type="is-success">PAYED</b-tag>
                <b-tag v-if="item.status == 'pending'" type="is-warning">PENDING</b-tag>
                <b-tag v-if="item.status == 'failed'" type="is-danger">REJECTED</b-tag>
              </td>
              <td>
                {{ moment(item.created_at).format("MMM DD YYYY HH:mm A") }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="loading_transations" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Profile</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Payed With</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
            <tr v-for="(item, index) in 15" :key="index">
              <td>
                <b-skeleton circle width="40px" height="40px"></b-skeleton>
              </td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="selected_transation" class="rigth-panel">
        <span class="closeButton" @click="selected_transation = null">Close</span>
        <userFullDetails :value="selected_transation" :user="selected_transation.user" type="transation"
          :user_type="selected_transation.user ? 'HOST' : 'GUEST'">
        </userFullDetails>
      </div>
      <div v-else class="rigth-panel no-data-panel">
        <widgetNotfound title="No Transation selected" subtitle="Select a transation to see its details"></widgetNotfound>
      </div>
    </div>
    <div class="wrapper-footer">
      <b-pagination :total="pagination_options.total" v-model="pagination_options.current" @change="getTransactions"
        :range-before="pagination_options.rangeBefore" :range-after="pagination_options.rangeAfter"
        :order="pagination_options.order" :size="pagination_options.size" :simple="pagination_options.isSimple"
        :rounded="pagination_options.isRounded" :per-page="pagination_options.perPage"
        :icon-prev="pagination_options.prevIcon" :icon-next="pagination_options.nextIcon" aria-next-label="Next page"
        aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page"
        :page-input="pagination_options.hasInput" :page-input-position="pagination_options.inputPosition"
        :debounce-page-input="pagination_options.inputDebounce">
      </b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    pagination_options: {
      total: 200,
      current: 1,
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      order: "",
      size: "",
      isSimple: false,
      isRounded: false,
      hasInput: false,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      inputPosition: "",
      inputDebounce: "",
    },
    loading_transations: true,
    selected_transation: null,
    form_filter: {
      page: 1,
      query: "",
    },
    finance_data: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getTransactions();
  },
  methods: {
    selectTransation(item) {
      let vm = this;
      vm.selected_transation = item;
    },
    searchTransations() {
      let vm = this;
      vm.getTransactions();
    },
    getTransactions(page = 1) {
      let vm = this;
      vm.loading_transations = true;
      vm.form_filter.page = page;
      vm.$store
        .dispatch("FINANCE_TRANSATIONS_GET_ALL", vm.form_filter)
        .then((response) => {
          vm.loading_transations = false;
          vm.finance_data = response.data.return;
          vm.pagination_options.total = vm.finance_data.total;
          vm.pagination_options.current = vm.finance_data.current_page;
          vm.pagination_options.perPage = vm.finance_data.per_page;
        })
        .catch((error) => {
          vm.loading_transations = false;
          console.log("FINANCE_TRANSATIONS_GET_ALL", error);
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      margin-right: 15px;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      margin-right: 10px;
      .control.has-icons-left.is-clearfix {
        @media (max-width: 700px) {
          min-width: 200px;
        }
      }

      .h-spacer {
        margin-right: 10px;
      }
      table {
        width: 100%;
        tr {
          th {
            white-space: nowrap;
          }
          td {
            white-space: nowrap;
            .tag-lists {
              display: flex;
              width: fit-content;
              flex-shrink: 0;
              min-width: 170px;
            }
          }
        }
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 125px);
    display: flex;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: calc(100% - 450px);
      display: flex;

      @media (max-width: 966px) {
        width: 50%;
      }
      @media (max-width: 700px) {
        width: 55%;
      }
      @media (max-width: 600px) {
        width: 100%;
      }
      .table-widget {
        // height: calc(100% - 60px);
        overflow-y: auto;
        border-radius: 0;
        button.openButton {
          display: none;
          width: fit-content;
          margin: 5px 0 0 5px;
          @media (max-width: 600px) {
            display: flex;
          }
        }
        table {
          width: 100%;
          tr {
            th {
              white-space: nowrap;
            }
            td {
              white-space: nowrap;
              .tag-lists {
                display: flex;
                width: fit-content;
                flex-shrink: 0;
                min-width: 170px;
              }
            }
          }
        }
      }
    }

    .rigth-panel {
      width: 450px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #e9e9e9;
      overflow-y: auto;
      position: relative;
      span.closeButton {
        position: absolute;
        right: 10px;
        top: 10px;
        color: red;
        cursor: pointer;
        display: none;
        @media (max-width: 600px) {
          display: block;
        }
      }

      @media (max-width: 966px) {
        width: 50%;
      }
      @media (max-width: 700px) {
        width: 45%;
      }
      @media (max-width: 600px) {
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: -450px;
        right: 0;
        transition: .5s;
        width: 65%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        &.active {
          right: 0;
        }
        &.no-data-panel {
          display: none;
        }
      }
      @media (max-width: 485px) {
        width: 80%;
      }

      .profile-widget {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .profile-image {
          width: 150px;
          height: 150px;
          object-fit: cover;
          border-radius: 50%;
          border: #fff solid 6px;
          z-index: 99;
          background: #fff;
        }

        .user-name {
          font-size: 22px;
        }
      }

      .right-panel-heading {
        color: rgb(0 0 0);
        padding: 9px 15px;
        margin-bottom: 6px;
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ddd;

        span {
          font-size: 18px;
        }
      }

      .guest-profile-contact {
        padding: 0px 10px;
        padding-top: 10px;
      }

      .profile-phone,
      .profile-email {
        padding-left: 30px;

        .label {
          font-size: 16px;
          color: #000000;
          margin-bottom: 0px;
        }

        .value {
          font-size: 14px;
          color: #616161;
        }
      }

      .subscription-widget {
        .subscription-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          border-bottom: 1px solid #e9e9e9;
          padding: 5px 25px;

          .subscription-item-left {
            display: flex;
            flex-direction: column;
            width: calc(100% - 30px);

            h3 {
              display: flex;

              * {
                margin-bottom: 0px !important;
              }

              .text {
                margin-left: 10px;
              }
            }

            .subscription-item-price {
              font-size: 12px;
              color: rgb(73, 73, 73);
              margin-top: 10px;
            }
          }

          .subscription-item-right {
            width: 30px;
          }
        }
      }

      .movie-widget {
        display: flex;
        flex-direction: column;

        .movie-item {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          border-bottom: 1px solid #ddd;
          padding: 5px 15px;

          .movie-item-image {
            width: 80px;
            height: 60px;
            object-fit: cover;
            border-radius: 10px;
            border: #fff solid 6px;
            z-index: 99;
            background: #fff;
            display: flex;
            align-items: center;
            justify-items: center;
            position: relative;

            img {
              width: 100%;
              height: 100%;
              border-radius: 6px;
            }

            .btn-play {
              background-color: #fff;
              border: none;
              display: flex;
              height: 30px;
              width: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              top: 20%;
              left: 28%;
              border-radius: 50%;
              border: 3px solid #000;

              .play-icon {
                font-size: 17px;
                color: #000;
                position: relative;
                left: 2px;
                top: 2px;
              }
            }
          }

          .movie-item-content {
            width: calc(100% - 80px);

            .movie-item-title {
              font-size: 19px;
              color: #000000;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .movie-item-time {
              font-size: 14px;
              color: #616161;
            }
          }
        }
      }
    }
  }

  .wrapper-footer {
    height: 65px;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0px 10px;
    border-top: 1px solid #ddd;
  }

  .add-subcription-form {
    height: 400px;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    margin-left: 30%;

    .add-subcription-header {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #e2e1e1;
    }

    .add-subcription-body {
      height: calc(100% - 120px);
      display: grid;
      grid-template-columns: 47% 47%;
      grid-gap: 20px;
      padding: 20px;

      .package-item {
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        padding: 10px;
        border-radius: 5px;
        position: relative;

        img {
          width: 15px;
          height: 15px;
          position: absolute;
          top: 8px;
          left: 8px;
          display: none;
        }

        &:hover {
          border: 1px solid #01a2a7;
        }

        &.active {
          border: 1px solid #01a2a7;

          h2 {
            color: #01a2a7;
          }

          p {
            color: #01a2a7;
          }

          img {
            display: block;
          }
        }
      }
    }

    .add-subcription-footer {
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-top: 1px solid #e2e1e1;
      display: flex;
      align-items: center;
      height: 60px;

      .h-spacer {
        margin: 0px 8px;
      }
    }
  }
}
</style>
